import { useQuery } from "@tanstack/react-query";
import { fetchServiceCatalog } from "@/lib/services/serviceCatalogService";
import { getServiceRegistry } from "@/lib/services/serviceRegistrySingleton";

export const serviceCatalogKey = ["serviceCatalog"];

async function fetchAndHydrateSnapshot() {
  // fetchServiceCatalog hydrates the ServiceRegistry singleton
  await fetchServiceCatalog();
  // return a JSON-friendly snapshot so React Query never resolves to undefined
  return getServiceRegistry().getSnapshot();
}

export function useServiceCatalog(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: serviceCatalogKey,
    queryFn: fetchAndHydrateSnapshot,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: options?.enabled ?? true,
  });
}
